
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchDataViewSuccess = (dataview:any)=>({
    type : 'fetch_needview_data_success',
    payload:dataview,
});
export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = orgapi.orgnizationneeds;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { needid:Id};
            const apiname = orgapi.orgneedview;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

